import React from "react";
import { convertToDollar } from "../../Helpers";
import "../../styles/ui.scss";

const BCLegend = ({ ...props }) => {
  return (
    <div>
      <div className={props.inline ? "legend-container-inline" : "legend-container"}>
        {(props && props.data && props.labels) && props.data.map((item, i) => {
          return (
            <div key={"legend_" + i} className="legend-item">
              {(i < props.data.length) && <span>
                <svg width="10" height="10">
                  {props.shape === "circle" ? <circle cx="5" cy="5" r="5" fill={props.colorArray[i]} /> :
                  <rect x="0" y="0" width="10" height="10" fill={props.colorArray[i]} />}
                </svg>
                {props.labels && props.labels.map((item, j) => {
                  let value = "";
                  if (item && item.value && item.format) {
                    switch(item.format) {
                      case "dollar":
                        value = props.data[i] && item.value && (props.data[i][item.value]) && (props.data[i][item.value]) !== 0 ? convertToDollar(props.data[i][item.value]) : (props.data[i][item.value]) === 0 ? "$0.00" : "";
                        break;
                      case "text":
                        value = item.value;
                        break;
                      default:
                        value = props.data[i][item.value];
                        break;
                    }
                  }
                  return(
                    <span key={"legend_text_" + j} className="legend-text">{value}</span>
                  );
                })}
              </span>}
              {props.spacing && <div className="legend-item-spacing" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BCLegend;